import React, { useEffect } from "react"
import axios from "axios"
import { navigate } from "@reach/router"

import styled from "styled-components"

import { H1 } from "../general/GeneralStyles"

const Step4 = props => {
  console.log("Step 4 props.formData " + props.formData)
  console.log(props.formData)
  useEffect(() => {
    if (props.formData.tokenId) {
      //Google Signup
      axios
        .post("/api/auth/googlesignup", props.formData)
        .then(response => {
          console.log(response)
          window.localStorage.setItem("user", JSON.stringify(response.data))
          if (response.data.user.is_admin) {
            navigate("/admin")
          } else {
            navigate("/account")
          }
        })
        .catch(error => {
          alert("Something went wrong please try again")
          console.log("error:", error)
        })
    } else if (props.formData.userId) {
      //Facebook Signup
      axios
        .post("/api/auth/facebooksignup", props.formData)
        .then(response => {
          console.log(response)
          window.localStorage.setItem("user", JSON.stringify(response.data))
          if (response.data.user.is_admin) {
            navigate("/admin")
          } else {
            navigate("/account")
          }
        })
        .catch(error => {
          alert("Something went wrong please try again")
          console.log("error:", error)
        })
    } else {
      //Email Signup
      axios
        .post("/api/auth/signup", props.formData)
        .then(response => {
          console.log(response)
          window.localStorage.setItem("user", JSON.stringify(response.data))
          if (response.data.user.is_admin) {
            navigate("/admin")
          } else {
            navigate("/account")
          }
        })
        .catch(error => {
          alert("Something went wrong please try again")
          console.log("error:", error)
        })
    }
  }, [])

  return (
    <>
      <H1>Loading...</H1>
    </>
  )
}

export default Step4
